<template>
    <div>
        <Topbar />
        <div class="card shadow mx-3 conteudo text-left" style="margin-top: 90px">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary-dark">
                    <i :class="`${title.icon} mr-2`"></i>{{ title.text }}
                    <div v-show="carregando" class="spinner-grow">
                        <span class="sr-only">Loading...</span>
                    </div>
                </h6>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12">
                        <fieldset v-if="isDataLoaded()" :disabled="carregando">
                            <Quadro :type="messageType" :message="message" />
                            <form>
                                <div class="d-print-none">
                                    <router-link
                                        :to="`/${this.baseUrl}`"
                                        id="btn_voltar"
                                        class="btn btn-secondary mr-1"
                                    >
                                        <i class="fa fa-arrow-left"></i> Voltar</router-link
                                    >
                                    <button type="button" id="btnSave" class="btn btn-primary mr-1" @click="salvar">
                                        Salvar
                                    </button>

                                    <hr />
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <fieldset>
                                            <div class="form-row">
                                                <InputAndLabel
                                                    column="1"
                                                    name="id"
                                                    label="ID"
                                                    type="text"
                                                    v-model="dados[idname].value"
                                                    readonly
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="vigencia_ini"
                                                    label="Vigência Início"
                                                    type="text"
                                                    v-mask="'##/##/####'"
                                                    v-model="dados.vigencia_ini.value"
                                                    :errorMessage="errors.vigencia_ini"
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="vigencia_fim"
                                                    label="Vigência Fim"
                                                    type="text"
                                                    v-mask="'##/##/####'"
                                                    v-model="dados.vigencia_fim.value"
                                                    :errorMessage="errors.vigencia_fim"
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="base"
                                                    label="Base"
                                                    type="number"
                                                    step="0.01"
                                                    v-model="dados.base.value"
                                                    :errorMessage="errors.base"
                                                    right
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="valor"
                                                    label="Valor"
                                                    type="number"
                                                    step="0.01"
                                                    v-model="dados.valor.value"
                                                    :errorMessage="errors.valor"
                                                    right
                                                />
                                                <InputAndLabel
                                                    column="2"
                                                    name="percseg"
                                                    label="% Seg."
                                                    type="number"
                                                    step="0.01"
                                                    v-model="dados.percseg.value"
                                                    :errorMessage="errors.percseg"
                                                    right
                                                />
                                            </div>
                                            <div class="form-row">
                                                <InputAndLabel
                                                    column="5"
                                                    name="contrato"
                                                    label="Contrato"
                                                    type="text"
                                                    v-model="dados.contrato"
                                                    readonly
                                                />                                                
                                                <SelectAndLabel
                                                    column="4"
                                                    name="idarm"
                                                    label="Armazenamento"
                                                    :options="combos.idarm"
                                                    v-model="dados.idarm.value"
                                                    :errorMessage="errors.idarm"
                                                />
                                            </div>                                            
                                        </fieldset>
                                    </div>
                                </div>                                
                            </form>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
        <Modal
            id="modalExcluir"
            title="Confirmar Exclusão"
            confirmClass="btn btn-danger"
            confirmText="Excluir"
            :confirmFunction="deletar"
        >
            Tem certeza que deseja excluir este armazenamento?
        </Modal>
        <ForbiddenModal />
        <LogoutModal />
        <Sidebar/>
    </div>
</template>

<script>
import api, { getUsername } from "../services/api";
import Topbar from "@/components/Topbar";
import Sidebar from '@/components/Sidebar.vue'
import InputAndLabel from "@/components/InputAndLabel";
import SelectAndLabel from "@/components/SelectAndLabel";
import Quadro from "@/components/Quadro";
import LogoutModal from "@/components/LogoutModal.vue";
import Modal from "@/components/Modal";
import ViewMixin from "./ViewMixin";
import $ from "jquery";
import {
    ClientErrorException,
    DEFAULT_ERROR_MESSAGE,
    PermissaoException,
    ServerErrorException,
    TokenInvalidoException,
    ValidationException,
} from "../services/exceptions";
import ForbiddenModal from "../components/ForbiddenModal.vue";

export default {
    name: "Armazenamento",
    mixins: [ViewMixin],
    components: {
        Topbar,
        Sidebar,
        LogoutModal,
        Modal,
        InputAndLabel,
        SelectAndLabel,
        Quadro,
        ForbiddenModal,
    },
    props: ["id"],
    data: function() {
        return {
            idname: "idarm_val",
            baseUrl: "armazenamentos",
            title: {
                icon: "fas fa-warehouse",
                text: "Armazenamentos",
            },
            combos: {
                idcliente: [],
            },
            // dados: {
            //   documento: ''
            // },
            mensagem: "",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.areYouSure(next);
    },
    mounted() {
        this.defineOperation(this.id);
        this.getCombo().then(this.getData);
    },
    methods: {
        async getCombo() {
            this.carregando = true;

            try {
                let response = await api.get(`/${this.baseUrl}/combosToSave`);
                let data = response.data;
                this.combos = data;
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
        async getData(id = this.id) {
            this.carregando = true;

            try {
                let response = await api.get(`/${this.baseUrl}/${id}`);
                let data = response.data;
                this.setData(data, ["idstatus", "status", "statuscolor", "statusbackground", "contrato"]);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
        async salvar() {
            this.carregando = true;

            try {
                let response;
                let id = this.dados[this.idname].value;
                let newData;
                let fieldsToDelete = ["idstatus", "status", "statuscolor", "statusbackground", "contrato"];
                if (this.operation === "update") {
                    newData = this.getDataToUpdate(fieldsToDelete);
                    response = await api.put(`/${this.baseUrl}/${id}`, newData);
                } else {
                    newData = this.getDataToInsert(fieldsToDelete);
                    response = await api.post(`/${this.baseUrl}`, newData);
                }
                let data = response.data;
                id = data.id;
                this.dados[this.idname] = { value: id, oldValue: id };
                this.operation = "update";

                this.updateData(newData);

                this.changeURL(`/${this.baseUrl}/${id}`);

                this.setMessage(data.successMessage, "success");
                this.errors = {};
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
        async deletar() {
            this.carregando = true;

            $("#modalExcluir").modal("hide");

            try {
                let id = this.dados[this.idname].value;
                await api.delete(`/${this.baseUrl}/${id}`);

                this.$router.push(`/${this.baseUrl}`);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },

        async postarMensagem() {
            this.carregando = true;
            $("#mensagemCard").collapse("hide");

            try {
                let response;
                let idlead = this.dados[this.idname].value;
                let mensagem = this.mensagem;
                response = await api.post(`/${this.baseUrl}/mensagem`, { idlead, mensagem });
                let dados = response.data;
                let { idatividade, data } = dados.result;

                this.dados.atividades.unshift({ idatividade, data, mensagem, usuario: getUsername() });

                this.setMessage(dados.successMessage, "success");
                this.errors = {};
                this.mensagem = "";
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
    },

    watch: {
        "dados.documento.value": {
            handler: function(newVal, oldVal) {
                console.log(newVal);
                console.log(oldVal);
            },
        },
    },
};
</script>

<style>
/* css */
</style>
